/*
 * Copyright (C) 2017 Spanning Cloud Apps. LLC  All rights reserved.
 */
import './radioButton.tpl.html';
import './radioButton.scss';

(function () {
  angular
    .module('shared.radioButton', [])
    .directive('sbsfRadioButton', directive)
    .controller('RadioButtonCtrl', ['$scope', controller]);

  /**
   * Defines the sbsf-radio-button directive.
   *
   * @returns {Object} - The directive settings
   */
  function directive() {
    return {
      controller: 'RadioButtonCtrl',
      templateUrl: 'shared/radioButton/radioButton.tpl.html',
      restrict: 'E',
      transclude: true,
      scope: {
        checked: '=',
        disabled: '=',
        onClick: '&'
      }
    };
  }

  /**
   * The controller for the directive.
   */
  function controller() {}
})();
